/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';
import { inject } from '@angular/core/testing';

export const API_BASE_URL = new InjectionToken('BASE_URL');

@Injectable()
export class ArtworkClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient,
    //@Inject(ConfigService) configservice:ConfigService,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = "https://pexAdmin.zeeranks.com";
    // this.baseUrl = "http://localhost:54904";
    //this.baseUrl = configservice.appConfig
  }



  uploadAssets(zipFile: File | null | undefined): Observable<UploadAssetsVM> {
    let url_ = this.baseUrl + '/api/Asset/UploadAssets';
    url_ = url_.replace(/[?&]$/, "");

    console.log(url_);

    const content_ = new FormData();

    if (zipFile !== null && zipFile !== undefined)
      content_.append("AssetsZipFile", zipFile, zipFile.name ? zipFile.name : "AssetsZipFile");
   
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processUploadAssets(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUploadAssets(<any>response_);
        } catch (e) {
          return <Observable<UploadAssetsVM>><any>_observableThrow(e);
        }
      } else
        return <Observable<UploadAssetsVM>><any>_observableThrow(response_);
    }));
  }

  protected processUploadAssets(response: HttpResponseBase): Observable<UploadAssetsVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UploadAssetsVM.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        console.log(_responseText);
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<UploadAssetsVM>(<any>null);
  }
  checkMatches(excelFile: File | undefined, userEmail: string): Observable<CheckMatchesVM> {
    let url_ = this.baseUrl + "/api/Match/CheckMatches";
    url_ = url_.replace(/[?&]$/, "");


    const content_ = new FormData();
    if (excelFile !== null && excelFile !== undefined)
      content_.append("ExcelFile", excelFile, excelFile.name ? excelFile.name : "ExcelFile");
      if (userEmail != null && userEmail != "")
      content_.append("UserEmail", userEmail );

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCheckMatches(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCheckMatches(<any>response_);
        } catch (e) {
          return <Observable<CheckMatchesVM>><any>_observableThrow(e);
        }
      } else
        return <Observable<CheckMatchesVM>><any>_observableThrow(response_);
    }));
  }

  protected processCheckMatches(response: HttpResponseBase): Observable<CheckMatchesVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CheckMatchesVM.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<CheckMatchesVM>(<any>null);
  }

}
export class UploadAssetsVM implements IUploadAssetsVM {

  constructor(data?: IUploadAssetsVM) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  statusCode?: number;
  errors?: ErrorDetails[] | undefined;

  static fromJS(data: any): UploadAssetsVM {
    data = typeof data === 'object' ? data : {};
    const result = new UploadAssetsVM();
    result.init(data);
    return result;
  }

  init(_data?: any) {
    if (_data) {
      this.statusCode = _data['statusCode'];
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (const item of _data['errors']) {
          this.errors!.push(ErrorDetails.fromJS(item));
        }
      }
    }
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['statusCode'] = this.statusCode;
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (const item of this.errors) {
        data['errors'].push(item.toJSON());
      }
    }
    return data;
  }
}

export interface IUploadAssetsVM {
  statusCode?: number;
  errors?: ErrorDetails[] | undefined;
}
export class ErrorDetails implements IErrorDetails {

  constructor(data?: IErrorDetails) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  errorTitle?: string | undefined;
  errorDescription?: string | undefined;

  static fromJS(data: any): ErrorDetails {
    data = typeof data === 'object' ? data : {};
    const result = new ErrorDetails();
    result.init(data);
    return result;
  }

  init(_data?: any) {
    if (_data) {
      this.errorTitle = _data['errorTitle'];
      this.errorDescription = _data['errorDescription'];
    }
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['errorTitle'] = this.errorTitle;
    data['errorDescription'] = this.errorDescription;
    return data;
  }
}

export interface IErrorDetails {
  errorTitle?: string | undefined;
  errorDescription?: string | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}

export abstract class BaseDto implements IBaseDto {
  id?: number | undefined;

  constructor(data?: IBaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): BaseDto {
    data = typeof data === 'object' ? data : {};
    throw new Error("The abstract class 'BaseDto' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IBaseDto {
  id?: number | undefined;
}


export class CheckMatchesVM implements ICheckMatchesVM {
  downloadLink?: string | undefined;
  statusCode?: number;
  errors?: ErrorDetails[] | undefined;

  constructor(data?: ICheckMatchesVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.downloadLink = _data["downloadLink"];
      this.statusCode = _data["statusCode"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"])
          this.errors!.push(ErrorDetails.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CheckMatchesVM {
    data = typeof data === 'object' ? data : {};
    let result = new CheckMatchesVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["downloadLink"] = this.downloadLink;
    data["statusCode"] = this.statusCode;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors)
        data["errors"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICheckMatchesVM {
  downloadLink?: string | undefined;
  statusCode?: number;
  errors?: ErrorDetails[] | undefined;
}


